module.exports = __webpack_public_path__ + "static/media/Sesame.fad2b1f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/Sesame.svg
// module id = 1122
// module chunks = 0